import type { Booking } from '@brighterly/lib-core-types/booking/interfaces'

import { useCsRoutes } from '@shared/api'

interface PingLessonApiReturn {
  pingLesson: (bookingId: number) => Promise<Booking | null>
}

export const usePingLessonApi = (): PingLessonApiReturn => {
  const { $axios } = useNuxtApp()

  const pingLesson = async (bookingId: number): Promise<Booking | null> => {
    const url = useCsRoutes('classroom.lessons.ping', {
      '[booking_id]': bookingId,
    })

    if (!url) {
      console.warn('missing url for classroom/ping-lesson.hook.ts')
      return null
    }

    try {
      const { data } = await $axios.get(url)

      if (data?.success) {
        return (data?.data?.booking ?? null) as Booking | null
      }

      return null
    } catch (err: any) {
      console.error('unable to retrieve classroom/ping-lesson.hook.ts:', err)

      return null
    }
  }

  return { pingLesson }
}